import React, { useCallback } from 'react';
import { DropdownProps } from 'semantic-ui-react';
import { endParty } from '../../api/user';
import { Socket } from 'socket.io-client';
import firebase from 'firebase/compat/app';

type ILeaveDialog = {
  open: boolean;
  setOpen: () => void;
  roomId: string;
  socket: Socket;
  participants: User[];
  nameMap: StringDict;
  pictureMap: StringDict;
  setMedia: (e: any, data: DropdownProps) => void;
  redirectToWatchPartyDomain: () => void;
  handleClickOnNo: () => void;
  owner: string | undefined;
  user: User | firebase.User;
};

const LeaveDialog: React.FC<ILeaveDialog> = ({
  open,
  setOpen,
  roomId,
  participants,
  socket,
  nameMap,
  pictureMap,
  setMedia,
  redirectToWatchPartyDomain,
  handleClickOnNo,
  owner,
  user,
}) => {
  const handleWatchPartyEnd = useCallback(
    async (roomId: string) => {
      try {
        if (user?.uid === owner) {
          await endParty(roomId);
          setMedia(null, { value: '' });
          socket.emit('CMD:endParty');
          setOpen();
          handleClickOnNo();
        } else {
          socket.emit('CMD:leaveVideo');
          setOpen();
          redirectToWatchPartyDomain();
        }
      } catch (e) {
        console.log(e);
      }
    },
    [
      socket,
      setMedia,
      handleClickOnNo,
      owner,
      user,
      redirectToWatchPartyDomain,
      setOpen,
    ]
  );

  return (
    <div
      className={`fixed inset-0 size-full z-[9999] bg-black/50 grid place-items-center ${
        open ? 'block' : 'hidden'
      }`}
    >
      <div className="gradient-modal overflow-hidden rounded-lg max-w-lg w-full relative">
        <div>
          <div>
            <div className="flex items-center justify-between p-3 bg-[#3d026c]">
              <h5 className="text-gradient-blue text-2xl">
                {owner === user?.uid ? 'End ' : 'Leave '} Confirmation
              </h5>
              <button
                onClick={() => {
                  setOpen();
                }}
                className="text-gradient-pink text-3xl font-bold"
              >
                <i className="ri-close-fill"></i>
              </button>
            </div>
            <p className="text-[#ae8a27] text-[18px] p-3 !my-5 block">
              Are you sure you want to {owner === user?.uid ? 'end ' : 'leave '}
              the watch party?
            </p>
          </div>
        </div>

        <div>
          <div className="flex items-center justify-end gap-3 p-4 border-t border-t-white/10">
            <>
              <button
                className="btn-gradient-red py-3 px-12 text-[16px] font-semibold rounded-full text-white duration-150 hover:opacity-70"
                onClick={() => setOpen()}
              >
                No
              </button>
              <button
                onClick={() => handleWatchPartyEnd(roomId)}
                className="gradient-outline-btn py-3 px-12 text-[16px] font-semibold rounded-full duration-150 hover:opacity-70"
              >
                <span>Yes</span>
              </button>
            </>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaveDialog;
